import { isString } from 'lodash';
import { useService } from '../../../../../redux/reducer/service';

export default function useIsNew({ newFlagData }) {
  const { serviceData } = useService();

  return (() => {
    if (!isString(newFlagData)) return;
    const { disposableNewButtons = {} } = serviceData ?? {};
    return !disposableNewButtons[newFlagData];
  })();
}
